import styles from './Textbox.module.scss';
import PropTypes from 'prop-types';
import Images from 'assets/Images';
export default function Textbox(props) {
	const { id, type, value, placeholder, onChange, disabled, whiteBg, infoContent, readonly, required, mandatory, onFocusOut, maxlength, minlength, label, last, error, name, errorMessage } = props;

	return (
		<>
			<div className={styles['textbox-row']}>
				{label && (
					<label>
						{label} {mandatory && <sup>*</sup>}
						{infoContent && (
							<div className={styles['textbox-row__helpContainer']}>
								<div className={styles['textbox-row__help']}>
									<img src={Images.help} />
								</div>
								<div className={styles['textbox-row__helpContent']}>{infoContent}</div>
							</div>
						)}
					</label>
				)}
				<input
					className={`${styles['textbox-row__input']} ${error && styles['textbox-row--error']} ${whiteBg && styles['textbox-row--white']}`}
					id={id}
					type={type}
					value={value || ''}
					name={name}
					placeholder={placeholder}
					disabled={disabled}
					readOnly={readonly}
					required={required}
					maxLength={maxlength}
					minLength={minlength}
					last={last}
					onChange={onChange}
					autoComplete='off'
					onBlur={onFocusOut}
				/>
				{error && <div className={styles['textbox-row__error']}>{errorMessage}</div>}
			</div>
		</>
	);
}

Textbox.propTypes = {
	id: PropTypes.string,
	type: PropTypes.string,
	value: PropTypes.any,
	placeholder: PropTypes.string,
	onChange: PropTypes.any,
	disabled: PropTypes.bool,
	readonly: PropTypes.bool,
	required: PropTypes.bool,
	mandatory: PropTypes.bool,
	maxlength: PropTypes.number,
	minlength: PropTypes.number,
	label: PropTypes.string,
	last: PropTypes.string,
	error: PropTypes.bool,
	name: PropTypes.string,
	errorMessage: PropTypes.string
};

Textbox.defaultProps = {
	id: '',
	type: '',
	value: '',
	placeholder: '',
	onChange: '',
	disabled: false,
	readonly: false,
	required: false,
	mandatory: false,
	maxlength: 120,
	minlength: 0,
	label: '',
	last: '',
	error: false,
	name: '',
	errorMessage: ''
};
